// extracted by mini-css-extract-plugin
module.exports = {"primaryButton":"WizardWrapper-primaryButton-iHJn0S","icon":"WizardWrapper-icon-uQznwQ","dropdownRow":"WizardWrapper-dropdownRow-2yD7Sg"};